import React, { useEffect } from "react";

import CommonSection from "../components/UI/CommonSection";
import Helmet from "../components/Helmet/Helmet";
import AboutSection from "../components/UI/AboutSection";
import { Container, Row, Col } from "reactstrap";
import driveImg from "../assets/all-images/drive.jpg";
import "../styles/about.css";

import AOS from 'aos';
import "aos/dist/aos.css"

const About = () => {
   useEffect(()=>{
    AOS.init({duration: 800})
   },[])
  return (
    <Helmet title="About">
      <CommonSection title="About Us" />
      <AboutSection aboutClass="aboutPage" />

      <section className="about__page-section mt-5" data-aos="fade-up">
        <Container>
          <Row>
            <Col lg="6" md="6" sm="12">
              <div className="about__page-img">
                <img src={driveImg} alt="" className="w-100 rounded-3" />
              </div>
            </Col>

            <Col lg="6" md="6" sm="12">
              <div className="about__page-content">
                <h2 className="section__title">
                  We Are Committed To Provide Safe Ride Solutions
                </h2>

                <p className="section__description">
                  Utilize our streamlined online booking platform, competitive
                  rates, and punctual service to navigate the city with ease.
                  Elevate your transportation experience with{" "}
                  <strong>Kimm Cabs</strong>—where each ride is a testament to
                  our dedication to excellence. Trust us to be your preferred
                  choice for unparalleled and professional cab services.
                </p>

                <p className="section__description">
                  Utilize our streamlined online booking platform, competitive
                  rates, and punctual service to navigate the city with ease.
                  Elevate your transportation experience with{" "}
                  <strong>Kimm Cabs</strong>—where each ride is a testament to
                  our dedication to excellence. Trust us to be your preferred
                  choice for unparalleled and professional cab services.
                </p>

                <div className=" d-flex align-items-center gap-3 mt-4">
                  <span className="fs-4">
                    <i class="ri-phone-line"></i>
                  </span>

                  <div>
                    <h6 className="section__subtitle">Need Any Help?</h6>
                    <h4>
                      <a href="tel:+254716650807">
                        +254&nbsp;716&nbsp;650&nbsp;807
                      </a>
                    </h4>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </Helmet>
  );
};

export default About;
